<template>
  <div :class="classes">
    <slot/>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		count?: number | string;
		gap?: number;
		classes?: string;
	}>(),
	{
		count: 2,
		gap: 2,
	},
);

const classes = computed(() => {
	return ["grid", `grid-cols-${props.count}`, `${props.classes}`, "gap-2"];
});
</script>
